import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {InventoryBarcodeReportModel} from "./inventory-barcode-report.model";

@Component({
    selector: "wbo-inventory-barcode-report",
    templateUrl: "./inventory-barcode-report.component.html",
    providers: [provideReportModel(InventoryBarcodeReportModel)]
})
export class InventoryBarcodeReportComponent extends AbstractReportPage {
    constructor(public model: InventoryBarcodeReportModel) {
        super();
    }
}
